import React, { Fragment, useEffect, useState, useRef } from "react";
import Flags from "country-flag-icons/react/3x2";
import Link from "../../linkWithQuery";
import Badge from "@material-ui/core/Badge";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import {
  UserLoginWrapper,
  UserDropdownList,
  UserIcon,
  UserInfoWrapper,
  UserInfoTop,
  UserDropdownItems,
  NoticeBell,
  DropdownItem,
  // NoticeBoard -- pl-568
} from "../style";
// import { TutorialNotice } from "./tutorialNoticeBoard";  -- pl-568
import Support from "./supportHub";
import SyncStatus from "./syncStatus";
import Tooltip from "../../toolTip/index";
import { hasIPMAccountIntegration } from "../../../utils/helpers";
import { DemoModeDisabledTooltip } from "common/toolTip/demoModeDisabledTooltip";
import { ProvisionalToggle } from "common/form/styled";
import { AntSwitch } from "common/switch";
import { useDispatch } from "react-redux";
import { toggleDemoMode } from "../store/actionCreators";

const renderFlag = (countryCode) => {
  const Flag = Flags[countryCode];
  return Flag ? <Flag className="flag" /> : null;
};

export function compareString(a, b) {
  var result =
    a.toString().toLowerCase().trim() > b.toString().toLowerCase().trim()
      ? 1
      : b.toString().toLowerCase().trim() > a.toString().toLowerCase().trim()
        ? -1
        : 0;
  return result;
}
export function UserInfoPart(props) {
  const {
    noticeNum,
    accountList,
    accountIndex,
    changeAccount,
    profile,
    canAccessAccount,
    accountConfig,
    accountInfo,
    isDemoMode,
    config,
    /*  -- pl-568
    setupProcess,
    setupExpand,
    free_trial,
    handleNotice,
    accountId, */
  } = props;

  const [overflow, setOverflow] = useState(false);
  const [openUserList, setOpenUserList] = useState(false);
  const name = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const node = name.current;
    const clientWidth = node.clientWidth;
    const scrollWidth = node.scrollWidth;
    if (clientWidth < scrollWidth) {
      setOverflow(true);
    } //check whether account name overflow the container
  }, []);

  /*  -- pl-568
  let processStatus = {}, processComSteps = 0;
  if (setupProcess.get("progress")) {
    processStatus = setupProcess.get("progress").toJS();
    processComSteps = setupProcess.get("completedSteps");
  }; */
  let accounts = accountList.sortBy((val) =>
    val.get("account_name").toString().toLowerCase(),
  );
  const checkHasSameCountry = (accounts) =>
    accounts.every((item) => item.country === accounts[0].country);
  let hasSameCountryAccounts = checkHasSameCountry(accounts.toJS());
  return (
    <div>
      <UserLoginWrapper>
        {hasIPMAccountIntegration(
          accountInfo?.get("integrations") || Object.freeze([]),
        ) && <SyncStatus {...props} />}
        <Support {...props} />

        {/* {role !== "user" && processComSteps !== 3 && (
          <Badge
            badgeContent={3 - processComSteps}
            color="error"
            overlap="rectangular"
            className="noticeBadge"
          >
            <NoticeBoard onClick={() => handleNotice("")} />
            {setupExpand && (
              <TutorialNotice
                processStatus={processStatus}
                processComSteps={processComSteps}
                days={free_trial.get("days")}
                handleNotice={handleNotice}
                accountId={accountId}
              />
            )}
          </Badge>
        )}  -- pl-568 */}
        <Badge
          badgeContent={noticeNum}
          color="error"
          overlap="rectangular"
          className="noticeBadge dashboard_step2"
        >
          <Link to="/notice">
            <NoticeBell />
          </Link>
        </Badge>

        <ClickAwayListener onClickAway={() => setOpenUserList(false)}>
          <UserDropdownList>
            <div
              id="account-selection"
              onClick={() => setOpenUserList(!openUserList)}
              className={openUserList ? "iconfont iconfontOpen" : "iconfont"}
            />
            <UserDropdownItems
              className="account-dropdown"
              visible={openUserList ? "visible" : "hidden"}
            >
              <DemoModeDisabledTooltip isHide={!isDemoMode}>
                <DropdownItem className={isDemoMode ? "disabled" : ""}>
                  <div className="icon profile" />
                  <div
                    className="title"
                    onClick={() => setOpenUserList(!openUserList)}
                  >
                    <Link
                      to="/manage-account/profile"
                      style={{ textDecoration: "none" }}
                      disabled={isDemoMode}
                    >
                      Profile
                    </Link>
                  </div>
                </DropdownItem>
              </DemoModeDisabledTooltip>

              {canAccessAccount && (
                <DemoModeDisabledTooltip isHide={!isDemoMode}>
                  <DropdownItem className={isDemoMode ? "disabled" : ""}>
                    <div className="icon manage-account" />
                    <div className="text">
                      <div
                        className="title"
                        onClick={() => setOpenUserList(!openUserList)}
                      >
                        <Link
                          to="/manage-account/view"
                          style={{ textDecoration: "none" }}
                          disabled={isDemoMode}
                        >
                          Account
                        </Link>
                      </div>
                      <div className="subtext">
                        {profile.get("accountName")}
                      </div>
                    </div>
                  </DropdownItem>
                </DemoModeDisabledTooltip>
              )}

              {["development", "dev", "local"].includes(config?.env) && (
                <DropdownItem>
                  <div className="icon demo-mode" />
                  <div className="text">
                    <div className="title">Demo Mode</div>
                    <div className="subtext">Test out Paylab</div>
                  </div>
                  <ProvisionalToggle>
                    <AntSwitch
                      checked={isDemoMode}
                      onChange={() => dispatch(toggleDemoMode(!isDemoMode))}
                      name="provisional-toggle"
                    />
                  </ProvisionalToggle>
                </DropdownItem>
              )}

              <div className="line" />

              {accounts.size > 1 ? (
                <Fragment>
                  <div className="switchAcc-title">Switch Accounts</div>
                  {accounts.map((item) => {
                    return (
                      <DropdownItem
                        key={item.get("account_id")}
                        className={
                          item.get("account_id") === accountIndex
                            ? "selected"
                            : ""
                        }
                        onClick={() => changeAccount(item.get("account_id"))}
                      >
                        <div className="icon flag">
                          {!hasSameCountryAccounts && (
                            <div className="flag">
                              {renderFlag(item.get("country"))}
                            </div>
                          )}
                        </div>
                        <div className="text">
                          <div className="title">
                            {item.get("account_name")}
                          </div>
                          <div className="subtext">
                            {item.getIn(["currency", "code"])}
                          </div>
                        </div>
                      </DropdownItem>
                    );
                  })}
                  <div className="line" />
                </Fragment>
              ) : null}
              <DropdownItem
                className="log-out"
                onClick={() => {
                  setOpenUserList(false);
                  localStorage.clear();
                  window.location = "/auth/logout";
                }}
              >
                <div className="icon log-out" />
                <div className="text">
                  <span className="title">Log Out</span>
                </div>
              </DropdownItem>
            </UserDropdownItems>
          </UserDropdownList>
        </ClickAwayListener>
        <UserIcon>
          <div onClick={() => setOpenUserList(false)} className="iconfont" />
        </UserIcon>
        <UserInfoWrapper>
          <UserInfoTop>{profile.get("userName")}</UserInfoTop>
          <Tooltip title={profile.get("accountName")} isHide={!overflow}>
            <UserInfoTop className="accountInfo" ref={name}>
              {!hasSameCountryAccounts && (
                <span className="flagContainer">
                  {renderFlag(accountConfig?.getIn(["country", "code"]))}
                </span>
              )}
              {profile.get("accountName")} (
              {accountConfig?.getIn(["currency", "code"])})
            </UserInfoTop>
          </Tooltip>
        </UserInfoWrapper>
      </UserLoginWrapper>
    </div>
  );
}
